const CANVAS_KEY_DELIMITER = '__';
export const toCanvasKey = (subPageIndex, areaType) => {
  return [subPageIndex, areaType].join(CANVAS_KEY_DELIMITER);
};
export const parseCanvasKey = canvasKey => {
  const splitted = canvasKey.split(CANVAS_KEY_DELIMITER);
  return {
    subPageIndex: parseInt(splitted[0]),
    areaType: splitted[1]
  };
};